import { Injectable } from '@angular/core';
import { ConfigurationsFilterVm, ConfigurationsModel } from '../models/configurations.model';
import { Observable } from 'rxjs';
import { BaseDataService } from '@core/service/base-data.service';
import { ListActionsService } from '@core/service/list-actions.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  private apiConfigurations = 'api/Configurations'

  constructor(
    private baseDataService: BaseDataService,
    private listActionsService: ListActionsService
  ) { }

  /** Purges (permanently deletes) every configuration matching the given list filters. */
  purgeConfigurations(configurationListFilters?: ConfigurationsFilterVm): Observable<any> {
    return this.listActionsService.purgeList(this.apiConfigurations, configurationListFilters);
  }

  /** Requests a server-generated Excel export of every configuration matching the given list filters. */
  exportConfigurationsToExcel(configurationListFilters?: ConfigurationsFilterVm): Observable<Blob> {
    return this.listActionsService.exportListToExcel(this.apiConfigurations, configurationListFilters);
  }

  createConfigurations(configurations: ConfigurationsModel) : Observable<any>{
    return this.baseDataService.makePostCall(`${this.apiConfigurations}`,configurations)
  }

  getConfigurations(id: string) : Observable<any>{
    return this.baseDataService.makeGetCall(`${this.apiConfigurations}/${id}`)
  }

  getConfigurationList() : Observable<ConfigurationsModel> {
    return this.baseDataService.makeGetCall(`${this.apiConfigurations}`)
  }

  getAllConfigurationList(configurationFilters?: ConfigurationsFilterVm) : Observable<ConfigurationsFilterVm>{
    return this.baseDataService.makePostCall(`${this.apiConfigurations}/list`,configurationFilters)
  }

  updateConfiguration(configurationReq?: ConfigurationsModel) : Observable<any> {
    return this.baseDataService.makePutCall(`${this.apiConfigurations}`,configurationReq)
  }
}
